import { FC } from 'react';

import { useFormContext } from 'react-hook-form';
import { Col, FormGroup, Label } from 'reactstrap';

import { BoximusPrime } from '@hsp/react-component-library';

import { SaveForm } from 'types/pages/audience-builder/shared/save';
import { s } from 'utilities';

const Description: FC = () => {
  const { register } = useFormContext<SaveForm>();

  const { ref, ...props } = register('description');

  return (
    <FormGroup row>
      <Label sm={4}>{s('Site.Description')}</Label>
      <Col sm={8}>
        <BoximusPrime
          {...props}
          multiLine
          placeholder={s(['Site.Enter', 'Site.Description'])}
          ref={ref}
          rows={10}
          type="textarea"
        />
      </Col>
    </FormGroup>
  );
};

export default Description;
